import { Navigate, useLocation } from 'react-router-dom';
import { BottomActions, Box, Nav, PageHeader } from '@dagens/carrot';
import { useTranslation } from '@dagens/frontend-i18n';
import { Form } from '@dagens/frontend-forms';
import { Page } from '../../../../components/page';
import { AddCustomerFormValues, defaultValue } from '../types';
import { CustomerContactForm } from '../../../components/customer-contact-form';
import { useMediaQuery } from '../../../../_common/hooks/useMediaQueries';
import { useOnSave } from './use-on-save';
import { AddCustomerContactNextButton as Next } from './next-button';
import { AddCustomerContactBackButton as Back } from './back-button';

export const AddCustomerContactPage = () => {
  const { desktopUp } = useMediaQuery();
  const { t } = useTranslation();
  const { onSave } = useOnSave();
  const { state }: { state: AddCustomerFormValues } = useLocation();

  if (
    !state?.organization ||
    !state?.billingName ||
    !state?.primaryEmail ||
    !state?.reminderEmail
  ) {
    return <Navigate to="/customers/add/start" />;
  }

  const title = t('producer:AddCustomer.reviewContactInformationPageHeader');
  const subtitle = `${t('producer:AddCustomer.headerAnnotation')} (3/4)`;

  return (
    <Form.Provider defaultValue={{ ...defaultValue, ...state }}>
      <Page
        backButton={<Back />}
        navMobileText={
          <>
            <Nav.ContextTitle>{title}</Nav.ContextTitle>
            <Nav.ContextSubtitle>{subtitle}</Nav.ContextSubtitle>
          </>
        }
        header={
          desktopUp && (
            <Box.FullWidth>
              <PageHeader title={title} subtitle={subtitle} />
            </Box.FullWidth>
          )
        }
        bottom={
          <BottomActions border>
            <BottomActions.Cancel to="/customers">
              {t('common:Cancel')}
            </BottomActions.Cancel>
            <Next onSubmit={onSave} />
          </BottomActions>
        }
      >
        <Box.FormWrapper>
          <Form onSubmit={onSave}>
            <CustomerContactForm defaultCustomerName={state.customerName} />
          </Form>
        </Box.FormWrapper>
      </Page>
    </Form.Provider>
  );
};
